import { render } from "./ProductShowcase.vue?vue&type=template&id=1367c45b&scoped=true"
import script from "./ProductShowcase.vue?vue&type=script&lang=js"
export * from "./ProductShowcase.vue?vue&type=script&lang=js"

import "./ProductShowcase.vue?vue&type=style&index=0&id=1367c45b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1367c45b"]])

export default __exports__